import Link from "next/link";
import React from "react";
import Image from "next/image";
const NowVurbmotoProspect = () => {
  return <>
      <section className="hero relative py-2 md:pt-10 pt-10">
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 dark:hidden" data-sentry-element="picture" data-sentry-source-file="now-vurbmoto-prospect-section.tsx">
          <figure className="h-[630px] w-full">
            <Image width={1519} height={712} className="w-full h-full object-cover" src="/images/gradient.jpg" alt="gradient" data-sentry-element="Image" data-sentry-source-file="now-vurbmoto-prospect-section.tsx" />
          </figure>
        </picture>
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block" data-sentry-element="picture" data-sentry-source-file="now-vurbmoto-prospect-section.tsx">
          <figure className="h-[630px] w-full">
            <Image width={1519} height={712} src="/images/gradient_dark.jpg" alt="gradient dark" className="w-full h-full object-cover" data-sentry-element="Image" data-sentry-source-file="now-vurbmoto-prospect-section.tsx" />
          </figure>
        </picture>

        <div className="relative" style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        marginTop: 100
      }}>
          <div style={{
          width: "50%"
        }}>
            <img src="https://vurb-web.vercel.app/images/logo/ProspectVurb-OnLight.svg" />
          </div>
          {/* <!-- Slider --> */}

          {/* <LorettaLynnCategories /> */}
        </div>

        <div className="container">
          <div className="pt-8 pb-6 text-center">
            <h1 className="text-jacarta-700 font-display mb-6 text-3xl dark:text-white lg:text-4xl xl:text-5xl">
              Amateur Moto is now Vurbmoto Prospect
            </h1>
            {/* <p className="dark:text-jacarta-200 mb-8 text-lg">
              Available on both iOS and Android.
             </p> */}
            <div className="inline-flex space-x-8 mt-20">
              <Link href="https://apps.apple.com/us/app/vurbmoto-prospect/id6741115753" data-sentry-element="Link" data-sentry-source-file="now-vurbmoto-prospect-section.tsx">
                <img src="https://www.vurbmoto.com/wp-content/uploads/2025/02/APP-iOS.png" />
              </Link>

              <Link href="https://play.google.com/store/apps/details?id=com.vurbtechnology.prospect&pli=1" data-sentry-element="Link" data-sentry-source-file="now-vurbmoto-prospect-section.tsx">
                <img src="https://www.vurbmoto.com/wp-content/uploads/2025/02/APP-Google.png" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default NowVurbmotoProspect;